export default __webpack_public_path__ + "static/media/arrowUpRight.fb593bfd.svg";